//Cart Drawer Custom Element JS

if(!customElements.get('cart-drawer')){
    class CartDrawer extends HTMLElement {
        constructor(){
            super();
            this.closeButton = this.querySelector('.drawer__close');
            this.closeButton.addEventListener('click', this.closeDrawer.bind(this));
        }

        // By Call this Function you can open Cart Drawer by this document.querySelector('cart-drawer').openDrawer();
        openDrawer = () => {
            this.classList.add('show-overlay');
            document.body.classList.add('overlay-open');
            lockBodyScroll()
        }

        // By Call this Function you can close Cart Drawer by this document.querySelector('cart-drawer').closeDrawer();
        closeDrawer = () => {
            this.classList.remove('show-overlay');
            document.querySelector('.link-item-with-icon.cart-link').classList.remove('active');
            document.body.classList.remove('overlay-open');
            unlockBodyScroll()
        }
    }

    customElements.define('cart-drawer', CartDrawer);
}


if(!customElements.get('quantity-selector')){
    class QuantitySelector extends HTMLElement {
        constructor(){
            super();
            this.buttonsPlus = this.querySelector('button[name="plus"]');
            this.buttonsMinus = this.querySelector('button[name="minus"]');
            this.buttonRemove = this.nextElementSibling;
            this.input = this.querySelector('input');
            this.currentValue = this.input.value;
            this.isUpdating = false;

            this.applyMaxToProduct = this.dataset.applyMaxToProduct === 'true' || this.dataset.applyMaxToProduct === true || !this.dataset.applyMaxToProduct;
            this.variantId = this.dataset.variantId ? parseInt(this.dataset.variantId) : null;

            // New metafield-based max quantity
            this.productMaxQuantity = this.dataset.productMaxQuantity ? parseInt(this.dataset.productMaxQuantity) : null;
            this.variantMaxQuantity = this.dataset.variantMaxQuantity ? parseInt(this.dataset.variantMaxQuantity) : null;

            this.buttonsPlus ? this.buttonsPlus.addEventListener('click', this.upQuantity.bind(this)) : '';
            this.buttonsMinus ? this.buttonsMinus.addEventListener('click', this.downQuantity.bind(this)) : '';
            this.buttonRemove ? this.buttonRemove.addEventListener('click', this.removeQuantity.bind(this)) : '';
            this.input ? this.input.addEventListener('change', this.changeQuantity.bind(this)) : '';

            this.checkMaxQuantity();
        }

        removeQuantity = () => {
            this.updateCart(true);
        }

        changeQuantity = (e) => {
            this.updateCart(false);
            if (!this.checkMaxQuantity(true)) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                return false;
            }
        }

        upQuantity = async () => {
            // Prevent spam clicks - if already updating, ignore
            if (this.isUpdating) {
                return;
            }

            const inputMax = this.input.max ? parseInt(this.input.max) : null;
            const currentValue = parseInt(this.input.value);
            const productId = parseInt(this.input.dataset.productId);

            try {
                const cartResponse = await fetch('/cart.js');
                const cartData = await cartResponse.json();

                let shouldBlock = false;

                // Check against input max attribute first
                if (inputMax && currentValue >= inputMax) {
                    shouldBlock = true;
                    this.buttonsPlus.disabled = true;
                    this.input.disabled = true;
                    return;
                }

                if (this.applyMaxToProduct) {
                    // Apply BOTH product-level max AND variant-level max

                    // Check product-level max
                    const productMax = this.productMaxQuantity || (this.dataset.maxQuantity ? parseInt(this.dataset.maxQuantity) : null);
                    if (productMax) {
                        let totalProductQuantity = 0;
                        cartData.items.forEach(item => {
                            if (item.product_id == productId) {
                                totalProductQuantity += item.quantity;
                            }
                        });

                        if (totalProductQuantity >= productMax) {
                            shouldBlock = true;
                        }
                    }

                    // Check variant-level max for THIS variant
                    if (this.variantMaxQuantity) {
                        let variantQuantity = 0;
                        cartData.items.forEach(item => {
                            if (item.variant_id == this.variantId) {
                                variantQuantity += item.quantity;
                            }
                        });

                        if (variantQuantity >= this.variantMaxQuantity) {
                            shouldBlock = true;
                        }
                    }
                } else {
                    // applyMaxToProduct is false: only check variant-level max
                    if (this.variantMaxQuantity) {
                        let variantQuantity = 0;
                        cartData.items.forEach(item => {
                            if (item.variant_id == this.variantId) {
                                variantQuantity += item.quantity;
                            }
                        });

                        if (variantQuantity >= this.variantMaxQuantity) {
                            shouldBlock = true;
                        }
                    } else {
                        // Fall back to legacy maxQuantity
                        const legacyMax = this.dataset.maxQuantity ? parseInt(this.dataset.maxQuantity) : null;
                        if (legacyMax) {
                            let variantQuantity = 0;
                            cartData.items.forEach(item => {
                                if (item.variant_id == this.variantId) {
                                    variantQuantity += item.quantity;
                                }
                            });

                            if (variantQuantity >= legacyMax) {
                                shouldBlock = true;
                            }
                        }
                    }
                }

                if (shouldBlock) {
                    this.buttonsPlus.disabled = true;
                    this.input.disabled = true;
                    return;
                }
            } catch (error) {
                console.error('Error checking max quantity:', error);
            }

            this.isUpdating = true;
            this.buttonsPlus.disabled = true;
            this.buttonsMinus.disabled = true;
            if (this.input) this.input.disabled = true;

            this.input.stepUp()
            this.updateCart(false);
        }

        downQuantity = () => {
            // Prevent spam clicks - if already updating, ignore
            if (this.isUpdating) {
                return;
            }

            this.isUpdating = true;
            this.buttonsPlus.disabled = true;
            this.buttonsMinus.disabled = true;
            if (this.input) this.input.disabled = true;

            this.input.stepDown()
            this.updateCart(false);
        }

        checkMaxQuantity = async (restrictInput) => {
            // Get the product ID for cart comparison
            const productId = parseInt(this.input.dataset.productId);
            const cartData = await fetch('/cart.js').then(res => res.json());

            let shouldDisable = false;

            if (this.applyMaxToProduct) {
                // Apply BOTH product-level max AND variant-level max

                // Check product-level max
                const productMax = this.productMaxQuantity || (this.dataset.maxQuantity ? parseInt(this.dataset.maxQuantity) : null);
                if (productMax) {
                    let totalProductQuantity = 0;
                    cartData.items.forEach(item => {
                        if (item.product_id == productId) {
                            totalProductQuantity += item.quantity;
                        }
                    });

                    console.log(`QuantitySelector (product-level): Product ${productId}, Current: ${totalProductQuantity}, Max: ${productMax}`);

                    if (totalProductQuantity >= productMax) {
                        shouldDisable = true;
                    }
                }

                // Check variant-level max for THIS variant
                if (this.variantMaxQuantity) {
                    let variantQuantity = 0;
                    cartData.items.forEach(item => {
                        if (item.variant_id == this.variantId) {
                            variantQuantity += item.quantity;
                        }
                    });

                    console.log(`QuantitySelector (variant-level on product-level): Variant ${this.variantId}, Current: ${variantQuantity}, Max: ${this.variantMaxQuantity}`);

                    if (variantQuantity >= this.variantMaxQuantity) {
                        shouldDisable = true;
                    }
                }
            } else {
                // applyMaxToProduct is false: only check variant-level max
                if (this.variantMaxQuantity) {
                    let variantQuantity = 0;
                    cartData.items.forEach(item => {
                        if (item.variant_id == this.variantId) {
                            variantQuantity += item.quantity;
                        }
                    });

                    console.log(`QuantitySelector (variant-level): Variant ${this.variantId}, Current: ${variantQuantity}, Max: ${this.variantMaxQuantity}`);

                    if (variantQuantity >= this.variantMaxQuantity) {
                        shouldDisable = true;
                    }
                } else {
                    // Fall back to legacy maxQuantity
                    const legacyMax = this.dataset.maxQuantity ? parseInt(this.dataset.maxQuantity) : null;
                    if (legacyMax) {
                        let variantQuantity = 0;
                        cartData.items.forEach(item => {
                            if (item.variant_id == this.variantId) {
                                variantQuantity += item.quantity;
                            }
                        });

                        console.log(`QuantitySelector (legacy): Variant ${this.variantId}, Current: ${variantQuantity}, Max: ${legacyMax}`);

                        if (variantQuantity >= legacyMax) {
                            shouldDisable = true;
                        }
                    }
                }
            }

            // Also check input max attribute as a final constraint
            const inputMax = this.input && this.input.max ? parseInt(this.input.max) : null;
            if (inputMax && parseInt(this.input.value) >= inputMax) {
                shouldDisable = true;
            }

            if (shouldDisable) {
                this.buttonsPlus.disabled = true;
                if (this.input) this.input.disabled = true;
            } else if (this.buttonsPlus) {
                this.buttonsPlus.disabled = false;
                if (this.input) this.input.disabled = false;
            }

            if (restrictInput) {
                // If current input value exceeds the input max attribute, restrict it
                const currentValue = parseInt(this.input.value);
                if (inputMax && currentValue > inputMax) {
                    this.input.value = inputMax;
                    this.input.dispatchEvent(new Event('change'));
                    return false;
                }
            }

            return true;
        }

        //Update Cart Drawer HTML
        updateCart = (remove) => {
            if('updateItem' in this.dataset){
                //Get Line Item Data
                const data = {
                    line : this.dataset.line * 1,
                    quantity : remove ? 0 : this.input.value,
                    //Assign Section Id which we want with response after add line item in cart
                    sections: ['cart-drawer' ],
                    sections_url: window.location.pathname,
                }

                const body = JSON.stringify(data);
                fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    const parsedState = JSON.parse(state);
                    const parser = new DOMParser()
                    const html = parser.parseFromString(parsedState.sections['cart-drawer'], "text/html");

                    const oldCartDrawer = document.querySelector('cart-drawer');
                    const newCartDrawer = html.querySelector('cart-drawer');

                    // Preserve app blocks
                    const oldBlocks = oldCartDrawer.querySelectorAll('.cart-drawer__block');
                    const newBlocks = newCartDrawer.querySelectorAll('.cart-drawer__block');

                    if (newBlocks.length === 0 && oldBlocks.length > 0) {
                        const newHeader = newCartDrawer.querySelector('.cart-drawer-header');
                        const newTitle = newHeader.querySelector('.drawer-title');
                        oldBlocks.forEach(block => {
                            newHeader.insertBefore(block.cloneNode(true), newTitle);
                        });
                    }

                    //Assign Current State to New Cart Drawer HTML
                    newCartDrawer.classList = oldCartDrawer.classList;
                    //Replace Current Cart Drawer with New Cart Drawer HTML
                    oldCartDrawer.replaceWith(newCartDrawer);
                    document.querySelector('.cart_count_latest').textContent = parsedState.item_count;

                    console.log(state)
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(async() => {
                    // Check max quantity on product form after cart update
                    // Use multiple timeouts to ensure it catches the update
                    const productForms = document.querySelectorAll('product-form');
                    const cartResponse = await fetch('/cart.js');
                    const cartData = await cartResponse.json();

                    productForms.forEach(productForm => {
                        console.log('Checking max quantity after cart update (immediate)');
                        if (productForm && typeof productForm.checkMaxQuantity === 'function') {
                            console.log('Checking max quantity after cart update (300ms)');
                            productForm.checkMaxQuantity(cartData);
                        }
                    });

                    // Re-enable buttons after update completes
                    // Note: this element is being replaced, so we can't re-enable on the old instance
                });
            }
        };
    }

    customElements.define('quantity-selector', QuantitySelector);
}

if(!customElements.get('product-form')){
    class ProductForm extends HTMLElement {
        constructor(){
            super();
            this.form = this.querySelector('form');
            this.form.addEventListener('submit', this.addProduct.bind(this));
            this.maxQuantity = this.dataset.maxQuantity ? parseInt(this.dataset.maxQuantity) : null;
            this.productId = this.dataset.productId;

            this.applyMaxToProduct = this.dataset.applyMaxToProduct === 'true' || this.dataset.applyMaxToProduct === true || !this.dataset.applyMaxToProduct;

            // New metafield-based max quantity attributes
            this.productMaxQuantity = this.dataset.maxQuantity ? parseInt(this.dataset.maxQuantity) : null;
            this.variantMaxQuantity = this.dataset.variantMaxQuantity ? parseInt(this.dataset.variantMaxQuantity) : null;

            console.log('[ProductForm] Constructor - dataset attributes:', {
                productMaxQuantity: this.dataset.maxQuantity,
                variantMaxQuantity: this.dataset.variantMaxQuantity,
                maxQuantity: this.dataset.maxQuantity,
                applyMaxToProduct: this.dataset.applyMaxToProduct,
                productId: this.productId
            });

            // Check max quantity on page load - always check, return early inside if no max is set
            this.checkMaxQuantity();

            setTimeout(() => {
                let installmentsText = document.querySelector('.pdp-installments-text shopify-payment-terms');
                if (installmentsText) {
                    let shadowRoot = installmentsText.shadowRoot
                    if (shadowRoot) {
                        shadowRoot.querySelector('#shopify-installments-content div').style.color = 'rgba(90, 49, 244, 1)';
                    }
                }
            }, 1000);
        }

        changeAllButtonsDisabledState = (disabled, changeText = true) => {
            const buttons = document.querySelectorAll(`product-form[data-product-id="${this.productId}"] button[name="add"]`);
            buttons.forEach(button => {
                if (disabled) {
                    button.setAttribute('disabled', 'disabled');
                } else {
                    button.removeAttribute('disabled');
                }

                if (!changeText) return;
                const buttonText = button.querySelector('span');
                if (buttonText) {
                    buttonText.textContent = disabled ? 'Max Purchase Limit Reached' : (button.dataset.bundleProduct ? 'Choose Products' : 'Add To Cart');
                }
            });
        }

        checkMaxQuantity = async (cartData) => {
            // Return if no max quantity is set anywhere
            if (!this.maxQuantity && !this.productMaxQuantity) return;

            try {
                if (!cartData) {
                    const cartResponse = await fetch('/cart.js');
                    cartData = await cartResponse.json();
                }

                // Get the current variant ID from the form
                const variantIdInput = this.form.querySelector('input[name="id"]');
                const currentVariantId = variantIdInput ? parseInt(variantIdInput.value) : null;

                let shouldDisable = false;

                if (this.applyMaxToProduct) {
                    // Apply BOTH product-level max AND variant-level max

                    // Check product-level max: custom.max_quantity
                    const productMax = this.productMaxQuantity || this.maxQuantity;
                    if (productMax) {
                        let totalProductQuantity = 0;
                        cartData.items.forEach(item => {
                            if (item.product_id == this.productId) {
                                totalProductQuantity += item.quantity;
                            }
                        });

                        /*console.log(`[ProductForm] Checking product-level max for product ${this.productId}:`, {
                            currentQuantity: totalProductQuantity,
                            effectiveMax: productMax
                        });*/

                        if (totalProductQuantity >= productMax) {
                            shouldDisable = true;
                            //console.log('[ProductForm] Disabling button - product max reached', { totalProductQuantity, productMax });
                        }
                    }

                    // Check variant-level max: custom.max_quantity_per_variant_optional for THIS variant
                    if (currentVariantId && this.variantMaxQuantity) {
                        const variantMax = parseInt(this.variantMaxQuantity);
                        let variantQuantity = 0;
                        cartData.items.forEach(item => {
                            if (item.variant_id == currentVariantId) {
                                variantQuantity += item.quantity;
                            }
                        });

                        /*
                            console.log(`[ProductForm] Checking variant-level max for variant ${currentVariantId}:`, {
                                currentQuantity: variantQuantity,
                                effectiveMax: variantMax
                            });
                        */

                        if (variantQuantity >= variantMax) {
                            shouldDisable = true;
                            //console.log('[ProductForm] Disabling button - variant max reached', { variantQuantity, variantMax });
                        }
                    }
                } else {
                    // applyMaxToProduct is false: only check variant-level max
                    if (currentVariantId && this.variantMaxQuantities[currentVariantId]) {
                        const variantMax = parseInt(this.variantMaxQuantities[currentVariantId]);
                        let variantQuantity = 0;
                        cartData.items.forEach(item => {
                            if (item.variant_id == currentVariantId) {
                                variantQuantity += item.quantity;
                            }
                        });

                        console.log(`[ProductForm] Checking variant-level max (applyMaxToProduct=false) for variant ${currentVariantId}:`, {
                            currentQuantity: variantQuantity,
                            effectiveMax: variantMax
                        });

                        if (variantQuantity >= variantMax) {
                            shouldDisable = true;
                            console.log('[ProductForm] Disabling button - variant max reached', { variantQuantity, variantMax });
                        }
                    } else {
                        // Fall back to legacy maxQuantity if no per-variant max
                        const legacyMax = this.maxQuantity;
                        if (legacyMax) {
                            let variantQuantity = 0;
                            cartData.items.forEach(item => {
                                if (item.variant_id == currentVariantId) {
                                    variantQuantity += item.quantity;
                                }
                            });

                            console.log(`[ProductForm] Checking legacy max for variant ${currentVariantId}:`, {
                                currentQuantity: variantQuantity,
                                effectiveMax: legacyMax
                            });

                            if (variantQuantity >= legacyMax) {
                                shouldDisable = true;
                                console.log('[ProductForm] Disabling button - legacy max reached', { variantQuantity, legacyMax });
                            }
                        }
                    }
                }

                if (shouldDisable) {
                    this.changeAllButtonsDisabledState(true);
                } else {
                    this.changeAllButtonsDisabledState(false);
                }
            } catch (error) {
                console.error('Error checking max quantity:', error);
            }
        }

        addProduct = async (event) => {
            event.preventDefault();

            // Pre-emptively check if adding would exceed max
            if (this.maxQuantity || this.productMaxQuantity) {
                try {
                    const cartResponse = await fetch('/cart.js');
                    const cartData = await cartResponse.json();

                    // Get the current variant ID from the form
                    const variantIdInput = this.form.querySelector('input[name="id"]');
                    const currentVariantId = variantIdInput ? parseInt(variantIdInput.value) : null;

                    let maxReached = false;

                    if (this.applyMaxToProduct) {
                        // Apply BOTH product-level max AND variant-level max

                        // Check product-level max
                        const productMax = this.productMaxQuantity || this.maxQuantity;
                        if (productMax) {
                            let totalProductQuantity = 0;
                            cartData.items.forEach(item => {
                                if (item.product_id == this.productId) {
                                    totalProductQuantity += item.quantity;
                                }
                            });

                            if (totalProductQuantity >= productMax) {
                                maxReached = true;
                                console.log('[ProductForm] Add blocked - product max reached', { totalProductQuantity, productMax });
                            }
                        }

                        // Check variant-level max for THIS variant
                        if (currentVariantId && this.variantMaxQuantities[currentVariantId]) {
                            const variantMax = parseInt(this.variantMaxQuantities[currentVariantId]);
                            let variantQuantity = 0;
                            cartData.items.forEach(item => {
                                if (item.variant_id == currentVariantId) {
                                    variantQuantity += item.quantity;
                                }
                            });

                            if (variantQuantity >= variantMax) {
                                maxReached = true;
                                console.log('[ProductForm] Add blocked - variant max reached', { variantQuantity, variantMax });
                            }
                        }
                    } else {
                        // applyMaxToProduct is false: only check variant-level max
                        if (currentVariantId && this.variantMaxQuantities[currentVariantId]) {
                            const variantMax = parseInt(this.variantMaxQuantities[currentVariantId]);
                            let variantQuantity = 0;
                            cartData.items.forEach(item => {
                                if (item.variant_id == currentVariantId) {
                                    variantQuantity += item.quantity;
                                }
                            });

                            if (variantQuantity >= variantMax) {
                                maxReached = true;
                                console.log('[ProductForm] Add blocked - variant max reached (applyMaxToProduct=false)', { variantQuantity, variantMax });
                            }
                        } else {
                            // Fall back to legacy maxQuantity
                            const legacyMax = this.maxQuantity;
                            if (legacyMax) {
                                let variantQuantity = 0;
                                cartData.items.forEach(item => {
                                    if (item.variant_id == currentVariantId) {
                                        variantQuantity += item.quantity;
                                    }
                                });

                                if (variantQuantity >= legacyMax) {
                                    maxReached = true;
                                    console.log('[ProductForm] Add blocked - legacy max reached', { variantQuantity, legacyMax });
                                }
                            }
                        }
                    }

                    if (maxReached) {
                        this.changeAllButtonsDisabledState(true);
                        return;
                    }
                } catch (error) {
                    console.error('Error checking max quantity:', error);
                }
            }

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            //Assign Section Id which we want with response after add line item in cart
            if (document.querySelector('cart-drawer')) {
                formData.append(
                  'sections',
                  ['cart-drawer']
                );
                formData.append('sections_url', window.location.pathname);
            }

            config.body = formData;

            // Disable button immediately to prevent double-clicks
            if (this.maxQuantity || this.productMaxQuantity) {
                // If there's a max quantity, disable all buttons for this product to prevent overshoot
                this.changeAllButtonsDisabledState(true, false);
            }

            // Add Product into Cart
            fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                const parser = new DOMParser()
                const html = parser.parseFromString(response.sections['cart-drawer'], "text/html");
                
                const oldCartDrawer = document.querySelector('cart-drawer');
                const newCartDrawer = html.querySelector('cart-drawer');
                
                // Preserve app blocks
                const oldBlocks = oldCartDrawer.querySelectorAll('.cart-drawer__block');
                const newBlocks = newCartDrawer.querySelectorAll('.cart-drawer__block');
                
                if (newBlocks.length === 0 && oldBlocks.length > 0) {
                    const newHeader = newCartDrawer.querySelector('.cart-drawer-header');
                    const newTitle = newHeader.querySelector('.drawer-title');
                    oldBlocks.forEach(block => {
                        newHeader.insertBefore(block.cloneNode(true), newTitle);
                    });
                }
                
                oldCartDrawer.replaceWith(newCartDrawer);

                fetch('/cart.js')
                .then(response => response.json())
                .then(data => {
                    let cartCountElement = document.querySelector('.cart_count_latest');
                    if (cartCountElement) {
                        cartCountElement.textContent = data.item_count;
                    }
                    document.querySelectorAll('.cart_count_latest_box').forEach(button => {
                        button.style.display = "flex";
                    })

                    // Check max quantity after adding to cart
                    this.checkMaxQuantity(data);
                })
                .catch(error => console.error("Cart Count Update Error:", error));

            }).catch(error => {
                console.log(error);
                // Re-enable button on error
                this.changeAllButtonsDisabledState(false);
            }).finally(() => {
                setTimeout(() => {
                    document.querySelector('cart-drawer').openDrawer();
                }, 500);
            });
        }
    }

    customElements.define('product-form', ProductForm);
}

document.querySelector('.cart-link').addEventListener('click', function(event){
    event.preventDefault();
    document.querySelector('cart-drawer').openDrawer();
});

var cartBox = document.getElementById("CartDrawer-Form");
if (cartBox) {
    var itemCount = parseInt(cartBox.getAttribute("data-item-count"));
    if (itemCount >= 3) {
        cartBox.classList.add("form-reset_addd3");
    }
}
